import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom';
import Auth from './component/Auth/auth';
import IRouter from './component/Interface/IRouter';
import mainRoutes from './component/routes/routes';
import PrivateRoutes from './View/Private.index';
import Login from './View/Public/Login/Login';
import { useAllowedPages } from './context/AllowedPagesContext';

function PrivateRouter({ children }: any) {
  const auth = Auth.checkAuth();
  auth ? <PrivateRoutes /> : <Navigate to="/login" />;
  return <PrivateRoutes />;
}


const Router = () => {
  const { isPageAllowed } = useAllowedPages();
  const filteredRoutes = mainRoutes.filter((route: IRouter) => isPageAllowed(route.path));

  return (
    <>
      <Routes>
        <Route element={<PrivateRouter />}>
          {filteredRoutes.map((data: IRouter) => {
            return (
              <Route
                key={data.path}
                path={data.path + "/*"}
                element={<data.element />}
              />
            )
          })}
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </>
  )
}

export default Router
